import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL } from './../../../../Containers/Config/index';
import { PUBLISH_RECORD_DATA, PUBLISH_RECORD_DATA_SUCCESS, PUBLISH_RECORD_DATA_ERROR } from '../../actionType';
import apiCall from './../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* publishRecord({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/publish-data`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: PUBLISH_RECORD_DATA_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: PUBLISH_RECORD_DATA_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: PUBLISH_RECORD_DATA_ERROR, payload: error });
  }
}

export function* watchPublishRecordSaga() {
  yield takeEvery(PUBLISH_RECORD_DATA, publishRecord);
}

function* publishRecordSaga() {
  yield all([fork(watchPublishRecordSaga)]);
}

export default publishRecordSaga;
